module.exports = __webpack_public_path__ + "static/media/1013409.32656cf2.png";